import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type { Product, ProductListParams } from '~/features/product/types/product.type';

/**
 * 제품 목록 조회
 * @description 제품 목록을 조회합니다
 * @endpoint GET /admin/products
 * @param params - 조회 파라미터
 * @returns 제품 목록
 */
export function getProductListApi(params?: ProductListParams) {
  return axiosInstance.get<PaginatedApiResponse<Product>>('/admin/products', { params });
}
